import { GET_COMMISSION_PLAN, ADD_COMMISSION_PLAN, ASSIGN_COMMISSION_PLAN, GET_COMMISSION_HISTORY, REMOVE_COMMISSION, DOWNLOAD_AGREEMENT, GET_UNASSIGNED_LIST, CLEAR_DOWNLOAD_AGREEMENT, GET_COMMISSION_REPORT, GET_COMMISSION_FAILURE_DETAILS, GET_COMMISSION_SUCCESS_DETAILS, GET_COMMISSION_CALCULATION_DETAILS, GET_COMMISSION_CALCULATION_HISTORY, GET_COMMISSION_CALCULATION_HISTORY_DETAIL,PREVIEW_INVOICE,
  CLEAR_PREVIEW_INVOICE, PREVIEW_RELEASED_INVOICE, PREVIEW_RETAILER_RELEASED_INVOICE,PREVIEW_RETAILER_RELEASED_INVOICE_PDF} from 'redux/admin-constants';

const initialState = { 
  commissionPlanData:[],
  commissionPlanCreate:[],
  commissionPlanAssign:[],
  commissionHistoryData:[],
  removeCommissionData:[],
  downloadCommission:[],
  unassignedList:[],
  commissionReportData: [],
  failureDetailsData: [],
  successDetailsData: [],
  calculationDetailsData: [],
  calculationHistoryData: [],
  calculationHistoryDetailData: [],
   previewInvoicePDF: null,
    previewReleasedInvoicePDF: null,
  previewRetailerReleasedInvoicePDF: null,
  previewRetailerReleasedInvoice: null,
}

const reducer = (state = initialState,  action) => {
const {
  type,
  payload
} = action;

switch (type) {

  case GET_COMMISSION_PLAN: {
    return {
      ...state,
      commissionPlanData: payload,
    }
  }
    case ADD_COMMISSION_PLAN: {
    return {
      ...state,
      commissionPlanCreate: payload,
    }
  }

      case ASSIGN_COMMISSION_PLAN: {
    return {
      ...state,
      commissionPlanAssign: payload,
    }
}

      case GET_COMMISSION_HISTORY: {
    return {
      ...state,
      commissionHistoryData: payload,
    }
}

case REMOVE_COMMISSION: {
  const removedPlanMappingId = payload?.plan_mapping_id;

  return {
    ...state,
    commissionHistoryData: state.commissionHistoryData?.filter(
      (item) => item.plan_mapping_id !== removedPlanMappingId
    ),
    removeCommissionData: payload,
  };
}

    case DOWNLOAD_AGREEMENT: {
    return {
      ...state,
      downloadCommission: payload,
    }
}


    case CLEAR_DOWNLOAD_AGREEMENT: {
      return {
        ...state,
        downloadCommission: null,
      };
    }


      case GET_UNASSIGNED_LIST: {
    return {
      ...state,
      unassignedList: payload,
    }
}

case GET_COMMISSION_REPORT: {
  return {
    ...state,
    commissionReportData: payload,
  }
}

case GET_COMMISSION_FAILURE_DETAILS: {
  return {
    ...state,
    failureDetailsData: payload,
  }
}

case GET_COMMISSION_SUCCESS_DETAILS: {
  return {
    ...state,
    successDetailsData: payload,
  }
}

case GET_COMMISSION_CALCULATION_DETAILS: {
  return {
    ...state,
    calculationDetailsData: payload,
  }
}

case GET_COMMISSION_CALCULATION_HISTORY: {
  return {
    ...state,
    calculationHistoryData: payload,
  }
}

case GET_COMMISSION_CALCULATION_HISTORY_DETAIL: {
  return {
    ...state,
    calculationHistoryDetailData: payload,
  }
}

case PREVIEW_INVOICE: {
    return {
      ...state,
      previewInvoicePDF: payload,
    }
  }

  case CLEAR_PREVIEW_INVOICE: {
    return {
      ...state,
      previewInvoicePDF: null,
       previewRetailerReleasedInvoicePDF: null,
       previewReleasedInvoicePDF: null,
    }
  }
   case PREVIEW_RELEASED_INVOICE: {
    return {
      ...state,
      previewReleasedInvoicePDF: payload,
    }
  }

  case PREVIEW_RETAILER_RELEASED_INVOICE: {
    return {
      ...state,
      previewRetailerReleasedInvoice: payload,
    };
  }
  case PREVIEW_RETAILER_RELEASED_INVOICE_PDF : {
    return {
      ...state,
      previewRetailerReleasedInvoicePDF: payload,
    }
  }
  
  default:
    return state;
  }
}

export default reducer;